import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline, Stagger, StaggerItem } from "./Reveal";
import { CAREER_AREAS, PARTNER_TYPES, IMAGES } from "../lib/content";

export const CareersPartners = () => (
  <section id="careers" data-testid="careers-section" className="relative bg-ivory text-navy py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      {/* Careers */}
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-6">
          <Overline dark>Careers</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">Build What's Next With Us.</h2>
          <p className="mt-6 text-navy/60 leading-relaxed max-w-xl">
            We are building teams across retail, furniture, finance education, research, and technology. If you want to help shape an emerging multi-business organization, we would love to hear from you.
          </p>
          <a href="#contact" data-testid="careers-cta" className="mt-8 inline-flex items-center gap-2 bg-navy text-ivory px-6 py-3 rounded-full font-medium hover:bg-charcoal transition-colors group">
            Send Your Profile
            <ArrowUpRight size={18} className="text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6">
          <Stagger className="flex flex-wrap gap-3">
            {CAREER_AREAS.map((a) => (
              <StaggerItem key={a}>
                <span className="inline-block text-sm border border-black/15 px-4 py-2 hover:border-gold-deep hover:text-gold-deep transition-colors">{a}</span>
              </StaggerItem>
            ))}
          </Stagger>
        </Reveal>
      </div>

      {/* Partners */}
      <div className="mt-28 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal delay={0.1} className="lg:col-span-6 order-2 lg:order-1">
          <div className="overflow-hidden">
            <img src={IMAGES.careers} alt="Partner with KRV Nexus" className="w-full h-[380px] object-cover" />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-6 order-1 lg:order-2">
          <Overline dark>Partners / Vendors</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight">Build With KRV Nexus</h2>
          <p className="mt-6 text-navy/60 leading-relaxed max-w-xl">
            For Wood Mart specifically, approved local furniture manufacturers and carpenters may participate in the vendor ecosystem — subject to quality, pricing, delivery, warranty, and service standards.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            {PARTNER_TYPES.map((p) => (
              <span key={p} className="text-sm border border-black/15 px-4 py-2 text-navy/70">{p}</span>
            ))}
          </div>
          <a href="#contact" data-testid="partners-cta" className="mt-8 inline-flex items-center gap-2 text-navy font-medium link-underline group">
            Become a Partner
            <ArrowUpRight size={18} className="text-gold-deep group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
